(function () {
  'use strict';

  angular.module('app').component('paymentProvidersPage', paymentProviderListCtrl());

  function paymentProviderListCtrl() {
    return {
      bindings: {},
      controller: PaymentProviderListCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/payment-providers/payment-providers-page.component.html',
    };
  }

  PaymentProviderListCtrl.$inject = [
    '$location',
    'UtilService',
    'AbilityService',
    'SessionService',
    'PaymentProviderService',

    // Angular downgraded service
    'companyService',
  ];

  function PaymentProviderListCtrl(
    $location,
    UtilService,
    AbilityService,
    SessionService,
    PaymentProviderService,

    // Angular downgraded service
    companyService
  ) {
    const vm = this;

    vm.UtilService = new UtilService(vm);

    vm.filterCriteria = PaymentProviderService.getFilterCriteria();

    vm.filterCriteria.by_date_from = vm.UtilService.startOfDayFormat(vm.UtilService.startOfMonth());
    vm.filterCriteria.by_date_to = vm.UtilService.endOfDayFormat(vm.UtilService.today());

    vm.permissions = {
      canCreate: AbilityService.can('create_paymentprovider_accountadmin'),
    };

    // Methods
    vm.createItem = createItem;
    vm.onShowItem = onShowItem;

    // Initializers
    getPaymentProviders();
    getCompany();

    function getPaymentProviders() {
      vm.loadingItems = true;
      PaymentProviderService.getPaymentProviders(vm.filterCriteria).then(function (data) {
        vm.items = data.items;
        vm.meta = data.meta;

        vm.totalItems = vm.meta.totalItems;

        vm.loadingItems = false;
      });
    }

    function getCompany() {
      const companyId = SessionService.getSelectedAccountCompany().id;

      companyService.getCompany(companyId, { skip_check_role: true }).subscribe((response) => {
        vm.paymentMethods = response.payment_methods.filter((method) => method.status == true);
      });
    }

    function createItem() {
      $location.path('/payment_providers/new');
    }

    function onShowItem(item, mode) {
      $location.path(`/payment_providers/${item.id}`).search({ mode: mode });
    }
  }
})();
